import Vue from 'vue'
// Config plugins provides $config and $apiConfig on global Vue object
export const config = {
  install (Vue) {
    Vue.$apiConfig = require('./api.json')
    Vue.$config = require('./' + process.env.NODE_ENV + '.json')
  }
}

Vue.use(config)



// WEBPACK FOOTER //
// ./src/configuration/index.js